import {createContext, useContext, useState} from 'react'

const AlphabetContext = createContext(null)

export function AlphabetProvider({ children }) {
  const [currentLetter, setCurrentLetter] = useState(null)
  const contextValue = { currentLetter, setCurrentLetter }

  return (
    <AlphabetContext value={contextValue}>
      {children}
    </AlphabetContext>
  )
}

export function useAlphabet() {
  return useContext(AlphabetContext)
}
